import React, { useState, useEffect } from 'react'
import { getApiTargetInfo } from 'core'
import { connect } from 'react-redux'
import CommonScreen from 'admin/component/CommonScreen'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'

import { strCol } from '@integec/grid-tools/lib/cols'
import {
  wind2AllPlant,
  getUsers,
  deleteWindUSerPlantAccess,
  getWindUSerPlantAccess,
  updateWindUSerPlantAccess,
} from 'api/pgads'
import { modifiedDateCol, modifierCol } from 'core/HeaderColTypeProps'
import { Label } from 'core/screen-util'
import { Button, Select } from 'antd'
import RA from 'ramda'

const title = 'Wind User Access Right'

const WindUserAccess = ({ apiTargetInfo }) => {
  const [insertEvent, setInsertEvent] = useState(false)
  const [PlantIdMap, setPlantIdMap] = useState({})
  const [plantList, setPlantList] = useState([])
  const [userList, setUserList] = useState([])
  const [userIdNameMap, setUserIdNAmeMap] = useState({})

  useEffect(
    _ => {
      getUsers(apiTargetInfo)().fork(
        _ => _,
        users => {
          setUserList(
            RA.sortBy(r => r.firstName || r.lastName || r.userName)(users)
          )
          const tplntIdMap = RA.compose(
            RA.fromPairs,
            RA.map(user => [
              user.userName,
              `${user.firstName} ${user.lastName || ''} (${user.userName})`,
            ])
          )(users)
          setUserIdNAmeMap(tplntIdMap)
        }
      )
      wind2AllPlant(apiTargetInfo).fork(
        _ => _,
        data => {
          setPlantList(RA.sortBy(d => d.plantName || d.plantId)(data))
          const tplntIdMap = RA.compose(
            RA.fromPairs,
            RA.map(t => [t.plantId, t.plantName])
          )(data)
          setPlantIdMap(tplntIdMap)
        }
      )
    },
    [apiTargetInfo]
  )

  const InsertComp = ({ insertData = {}, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns:
            '100px 300px 100px 400px 100px 200px auto auto auto',
          gap: 10,
        }}
      >
        <Label>Plant :</Label>
        <Select
          value={insertData.plantId}
          data-cy="plant"
          onChange={value => setInsertData({ ...insertData, plantId: value })}
        >
          {plantList?.map(({ plantId, plantName }) => (
            <Select.Option key={plantId} value={plantId} data-cy="plant">
              {plantName}
            </Select.Option>
          ))}
        </Select>
        <Label>User Name :</Label>
        <Select
          value={insertData.userName}
          data-cy="username"
          onChange={userName => setInsertData({ ...insertData, userName })}
          showSearch
        >
          {userList?.map(u => (
            <Select.Option
              value={u.userName}
              key={u.userName}
              data-cy="username"
            >
              {userIdNameMap[u.userName]}
            </Select.Option>
          ))}
        </Select>

        <Label>Access Right :</Label>
        <Select
          value={insertData.accessRight}
          data-cy="accessright"
          onChange={value =>
            setInsertData({ ...insertData, accessRight: value })
          }
        >
          <Select.Option key="R" value="R" data-cy="accessright">
            READ
          </Select.Option>
          <Select.Option key="W" value="W" data-cy="accessright">
            WRITE
          </Select.Option>
        </Select>
        <Button type="primary" onClick={() => onAdd(true)}>
          Add
        </Button>
        <Button type="primary" onClick={() => onAdd(false)}>
          Add & Hide
        </Button>
        <Button type="danger" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    )
  }

  const SolarUSerAccessHeaders = [
    strCol({
      ident: 'plantId',
      display: 'Plant',
      isKey: true,
      width: 250,
      // ellipsis: true,
      // alignment: 'left',
      sortOrder: 'asc',
      ...toSelectionColProps(PlantIdMap),
    }),
    strCol({
      ident: 'userName',
      display: 'User Name',
      isKey: true,
      sortOrder: 'asc',
      width: 400,
      ...toSelectionColProps(userIdNameMap),
    }),
    strCol({
      ident: 'accessRight',
      display: 'Access Right',
      isRequired: true,
      sortOrder: 'asc',
      ...toSelectionColProps({ R: 'READ', W: 'WRITE' }),
    }),
    modifierCol,
    modifiedDateCol,
  ]

  return (
    <CommonScreen
      title={title}
      header={SolarUSerAccessHeaders}
      saveTask={updateWindUSerPlantAccess}
      retrieveTask={getWindUSerPlantAccess}
      deleteTask={deleteWindUSerPlantAccess}
      autoRetrieve
      // widthOffset={50}
      insertComp={insertEvent && InsertComp}
      insertCompHeight={50}
      onInsertEvent={b => setInsertEvent(b)}
      autoFixColByKey={false}
      headerRowHeight={30}
      totalWidth={150 + 650 + 700 + 150}
      sortOptions={SolarUSerAccessHeaders}
      defaultInsertData={{ accessRight: 'R' }}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(WindUserAccess)
